export const FILTERS_VIEW_EVENTS = {
    APPLY: 'filters-view-apply',
    CLEAR: 'filters-view-clear',
};
export const FILTERS_STORE_EVENTS = {
    CHANGE: 'filters-store-change',
    CLEAR: 'filters-store-clear',
};
export const FILTERS_PRESENTER_EVENTS = {
    APPLY: 'filters-presenter-apply',
    CHANGE: 'filters-presenter-change',
};
export const QUICK_FILTERS_VIEW_EVENTS = {
    PRESET_CLICK: 'quick-filters-view-preset-click',
    CATEGORY_CLICK: 'quick-filters-view-category-click',
    CATEGORY_APPLY: 'quick-filters-view-category-apply',
    CLEAR_CLICK: 'quick-filters-view-clear-click',
};
export const QUICK_FILTERS_POPUP_EVENTS = {
    APPLY: 'quick-filters-popup-apply',
    SHOW: 'quick-filters-popup-show',
    HIDE: 'quick-filters-popup-hide',
};
